import OrgSidebar from "@/components/OrgSidebar"
import { tracker } from '@openreplay/tracker';
import { Menu } from "lucide-react"
import { useContext, createContext, useState } from "react"
import {usePage} from "@inertiajs/react";



type Props = {
  activeSection: string
  children: React.ReactNode
  user_permissions: string[]
}

type SidebarContextType = {
  showSidebar: boolean
  setShowSidebar: (show: boolean) => void
}
const SidebarContext = createContext<any>(null)

export function useSidebar() {
  return useContext(SidebarContext)
}

export default function OrgLayout({ activeSection, children}: Props) {
  const [showSidebar, setShowSidebar] = useState<boolean>(false)
  const { props: { user ,user_permissions } } = usePage()
  tracker.setUserID(user?.email); // after tracker.start()



  console.log("User permissions in OrgLayout:", user_permissions)

  return (
    <div className="flex h-screen bg-background">
      <SidebarContext.Provider value={{ showSidebar, setShowSidebar }}>
        <OrgSidebar activeSection={activeSection || "global_settings"} user_permissions={user_permissions} showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
        <main className="flex-1 flex md:gap-4 justify-between md:p-6 overflow-y-auto ">
          {children}
        </main>
      </SidebarContext.Provider>
    </div>
  )
}

